function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "./index.less";
import { Flex, Tag } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { useDeepCompareEffect } from 'ahooks';
var Tags = function Tags(props) {
  var tagsData = props.tagsData,
    onSelectTag = props.onSelectTag,
    resetKey = props.resetKey;
  // 当前选中项列表
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedTags = _React$useState2[0],
    setSelectedTags = _React$useState2[1];

  /**
   * 初始化选中项
   */
  var setSelectTag = function setSelectTag() {
    var currentTag = tagsData.filter(function (item) {
      return item.isCheck === true;
    });
    setSelectedTags(currentTag);
  };

  // useDeepCompareEffect(() => {
  //   const checkIds = checkList?.map((item) => item.value);
  //   let newTags = tagsData.map((item: SurveyOption) => {
  //     return {
  //       ...item,
  //       isCheck: checkIds?.includes(item.value),
  //     };
  //   });

  //   setSelectedTags(newTags);
  // }, [checkList]); // 这里传入深层依赖项数组或对象

  useDeepCompareEffect(function () {
    setSelectTag();
  }, [tagsData, resetKey]); // 这里传入深层依赖项数组或对象

  var className = props.className;
  var classes = classNames('iron-tags', className);
  var handleChange = function handleChange(tag, checked) {
    var nextSelectedTags = [];
    if (checked) {
      // 对选中项新增新的项
      nextSelectedTags = [].concat(_toConsumableArray(selectedTags), [_objectSpread(_objectSpread({}, tag), {}, {
        isCheck: checked
      })]);
    } else {
      // 从选中项记录列表中排除当前项目
      nextSelectedTags = selectedTags.filter(function (t) {
        return t.value !== tag.value;
      });
    }
    setSelectedTags(nextSelectedTags);
    if (!onSelectTag) return;
    onSelectTag(nextSelectedTags);
  };
  return /*#__PURE__*/React.createElement(Flex, {
    gap: 8,
    wrap: true,
    align: "center",
    justify: "center",
    className: classes
  }, tagsData.map(function (tag) {
    return /*#__PURE__*/React.createElement(Tag.CheckableTag, {
      key: tag.value,
      checked: selectedTags.filter(function (o) {
        return o.value === tag.value;
      }).length !== 0,
      onChange: function onChange(checked) {
        return handleChange(tag, checked);
      },
      className: "tag-style"
    }, tag.label);
  }));
};
export default Tags;